module.exports = __webpack_public_path__ + "static/media/velour7D.84de74aa.jpg";